export const TYPES = Object.freeze({
  LIGHT: "light",
  DARK: "dark"
});
export const THEMES = Object.freeze({
  RED_LIGHT: "redLight",
  RED_DARK: "redDark",
  BLUE_LIGHT: "blueLight",
  BLUE_DARK: "blueDark"
});
export const IMAGES = Object.freeze({
  LOGO: "logo",
  DRIVER: "driver",
  PARCEL_LOGO: "parcelLogo",
  DRIVER_BG: "driverBgBanner",
  COLLECT_FROM_PICKUP: "collectFromPickup",
  COLLECT_FROM_DEPOT: "collectFromDepot",
  TRACKING_BG: "trackingBg",
  SWITCH_COLOR: "switchBtn",
  VOUCHER_DEFAULT: "voucherDefault",
  SPINNER: "spinner",
  MAP: "mapBg",
  COLLECT_FROM_DEPOT_MOBILE: "collectFromDepotMobile",
  COLLECT_FROM_PICKUP_MOBILE: "collectFromPickupMobile",
  DRIVER_BG_MOBILE: "driverBgBannerMobile"
});